import MediaService from '../services/MediaService';
import {
  normalizePhotoFromApi,
  normalizeVideoFromApi,
  revokePreviewUrl,
} from './mediaUtils';

const uploadPendingMedia = async (item, type) => {
  if (!item?.file) {
    throw new Error('Fichier média manquant pour l\'upload');
  }

  const uploaded = await MediaService.uploadFile(item.file, type, {
    alt: item.alt || '',
    fileName: item.name || item.fileName,
  });

  revokePreviewUrl(item);
  return type === 'image' ? normalizePhotoFromApi(uploaded) : normalizeVideoFromApi(uploaded);
};

export const preparePhotoForApi = async (photo) => {
  if (!photo) return null;

  if (photo.id) {
    return { id: photo.id, alt: photo.alt || '' };
  }

  const uploaded = await uploadPendingMedia(photo, 'image');
  return { id: uploaded.id, alt: uploaded.alt || photo.alt || '' };
};

export const prepareVideoForApi = async (video) => {
  if (!video) return null;

  if (video.id) {
    return { id: video.id, alt: video.alt || '' };
  }

  const uploaded = await uploadPendingMedia(video, 'video');
  return { id: uploaded.id, alt: uploaded.alt || video.alt || '' };
};

export const prepareProductMediaForSave = async (media = {}) => {
  const photos = await Promise.all((media.photos || []).map(preparePhotoForApi));
  const videos = await Promise.all((media.videos || []).map(prepareVideoForApi));

  return {
    photos: photos.filter(Boolean),
    videos: videos.filter(Boolean),
  };
};
